import {FormatNumberOptions} from "react-intl";

export const formatToEuro: FormatNumberOptions = {
    style: "currency",
    currency: "EUR"
}
